import type { Parser } from 'bowser';
import * as Bowser from 'bowser';
import { create } from 'zustand';

// @ts-ignore
const bowser: typeof Bowser = Bowser.default;

export interface DeviceInfoState extends Parser.ParsedResult {
  screen: {
    width: number;
    height: number;
    orientation: 'portrait' | 'landscape';
  };
  isMobile: boolean;
  isTablet: boolean;
  isPortrait: boolean;
  isTouchScreen: boolean;
}

/*
 * Hook to get device information with additional bowser information
 *
 * const {isMobile, isPortrait, browser, platform, os, engine, screen } = useDeviceInfo();
 */
export const useDeviceInfo = create<DeviceInfoState>((set) => {
  const result = bowser.parse(globalThis.navigator.userAgent);

  // Screen information
  const mediaQueryList = globalThis.matchMedia('(orientation: portrait)');
  const setOrientation = (isPortrait: boolean) => set({ isPortrait });
  const handleOrientationChange = (event: MediaQueryListEvent) => {
    const isPortrait = event.matches;
    setOrientation(isPortrait);
  };
  mediaQueryList.addEventListener('change', handleOrientationChange);

  const screen = {
    width: globalThis.screen.width,
    height: globalThis.screen.height,
    orientation: (mediaQueryList.matches ? 'portrait' : 'landscape') as 'portrait' | 'landscape',
  };

  const isPortrait = mediaQueryList.matches;
  const isTablet = result.platform.type === 'tablet';
  const isMobile = result.platform.type === 'mobile';
  const isTouchScreen = window.ontouchstart !== undefined;

  return {
    ...result,
    screen,
    isMobile,
    isPortrait,
    isTablet,
    isTouchScreen,
  };
});
